export default __webpack_public_path__ + "static/media/shape-oval.7ff607ab.svg";